import BaseService from '../base';

class Label extends BaseService {
  getLabels() {
    return {
      query: () => ({
        url: 'labels',
      }),
      providesTags: () => [{ type: this.tagType }],
    };
  }
}

export default new Label('labels', 'Label');
